import _isArray from 'lodash/isArray';
import _isObject from 'lodash/isObject';
import debug from './debug';

export function arrayDiff(a, b) {
    // stringify values to compare objects
    const toSet = (arr) => new Set(_isArray(arr) ? arr.map((x) => JSON.stringify(x)) : []);
    const complement = (setX, setY) => [...setX].filter((x) => !setY.has(x)).map((x) => JSON.parse(x));
    const setA = toSet(a);
    const setB = toSet(b);
    const added = complement(setA, setB);
    const removed = complement(setB, setA);
    return {
        added,
        removed,
    };
}

export function objectDiff(a, b, diff = {}, keyPrefix = '', keysForJsonDiff = []) {
    if (!_isObject(b)) {
        b = {};
    }
    return Object.keys(a).reduce((acc, key) => {
        const fullKey = keyPrefix ? keyPrefix + '.' + key : key;
        const value = a[key];
        const prevValue = b[key];
        if (keysForJsonDiff.includes(fullKey)) {
            try {
                if (JSON.stringify(value) !== JSON.stringify(prevValue)) {
                    acc[fullKey] = value;
                }
            } catch (e) {
                debug.warn('failed to stringify and compare values', e, a, b);
                acc[fullKey] = value;
            }
        } else if (_isArray(value)) {
            const arrDiff = arrayDiff(value, prevValue);
            if (arrDiff.added.length > 0 || arrDiff.removed.length > 0) {
                acc[fullKey] = arrDiff;
            }
        } else if (_isObject(value)) {
            objectDiff(value, prevValue, acc, fullKey, keysForJsonDiff);
        } else if (value !== prevValue) {
            acc[fullKey] = value;
        }
        return acc;
    }, diff);
}
